module.exports = __webpack_require__.p + "84a98a7cd27d9d43d40469676a1d06ef.jpg";